import { RefrescarTokenME } from './../../open-api/model/refrescarTokenME';
import { AccesoService } from './../../open-api/api/acceso.service';
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppToastService } from '../services/app-toast.service';
import { Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserModel } from '../models/user.model';
import Swal from 'sweetalert2';

@Injectable()
export class HttpErrorInterceptorInterceptor implements HttpInterceptor {

  user: UserModel = {};

  constructor(
    private authService: AuthService,
    private accesoService: AccesoService,
    private toastService: AppToastService,
    private router: Router,
    private spinner: NgxSpinnerService
  ) {
    this.authService.user.subscribe(user => {
      this.user = user;
    });
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return next.handle(request)
      .pipe(
        catchError((error: HttpErrorResponse) => {
          if (error.status === 401) {
            const parametro: RefrescarTokenME = {
              token: this.user.token
            };
            return this.accesoService.apiV10AccesoRefrescarTokenPost(parametro).pipe(
              switchMap(respuesta => {
                this.user.token = respuesta.token;
                this.authService.setUser(this.user);
                const clonedRequest = request.clone({
                  setHeaders: {
                    authorization: `Bearer ${respuesta.token}`
                  }
                });
                return next.handle(clonedRequest);
              }),
              catchError(err => {
                this.authService.LogOut();
                Swal.fire({
                  title: "La sesión ha caducado",
                  text: "Vuelva a iniciar sesión.",
                  confirmButtonText: "Ok",
                  confirmButtonColor: "#3b7851",
                  allowOutsideClick: false,
                }).then((result) => {
                  if (result.isConfirmed) {
                    window.location.reload();
                  }
                });
                return throwError(err);
              })
            );
          }

          let errorMsg = '';
          typeof (error.error) === 'object' ? errorMsg = 'Ha ocurrido un problema, por favor intenta mas tarde.' : errorMsg = error.error;
          const msg = errorMsg.split('|').length > 1 ? errorMsg.split('|')[1] : errorMsg;
          if (errorMsg.split('|').length > 1) {
            this.toastService.show('' + msg, 'bg-warning text-dark');
          } else {
            this.toastService.show('' + msg, 'bg-danger text-light');
          }
          this.spinner.hide();
          if (typeof(error.error) === 'object') {
            // localStorage.clear();
            // this.authService.LogOut();
            // this.router.navigate(['login']);
          }
          return throwError(errorMsg);
        })
      );
  }
}
